export const UPLOAD_ITEM_STATUS = {
  pending: "pending",
  uploading: "uploading",
  encrypting: "encrypting",
  done: "done",
  error: "error",
} as const;

export type UploadItemStatus =
  (typeof UPLOAD_ITEM_STATUS)[keyof typeof UPLOAD_ITEM_STATUS];
